import { Linkedin, BookOpen, Mic, GraduationCap } from 'lucide-react';

export function FormationInstructor() {
  return (
    <section className="py-24 bg-aspexit-gray-light">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-heading font-extrabold text-aspexit-black mb-8 text-center">
            À propos de votre formateur
          </h2>

          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="grid grid-cols-1 md:grid-cols-[auto_1fr] gap-8">
              {/* Photo */}
              <div className="flex justify-center md:justify-start">
                <img
                  src="/corentin-avatar.jpg"
                  alt="Corentin Leroux"
                  className="w-32 h-32 rounded-full object-cover border-4 border-aspexit-red"
                  onError={(e) => {
                    (e.target as HTMLImageElement).src =
                      'https://ui-avatars.com/api/?name=Corentin+Leroux&background=F06C6E&color=fff&size=128';
                  }}
                />
              </div>

              {/* Content */}
              <div>
                <h3 className="text-2xl font-heading font-bold text-aspexit-black mb-2">
                  Corentin Leroux
                </h3>
                <p className="text-aspexit-red font-semibold mb-4">
                  Expert numérique agricole
                </p>

                <p className="text-aspexit-gray mb-6 leading-relaxed">
                  10+ ans d'expérience en data science agricole et
                  cartographie. Formateur certifié QUALIOPI, Corentin accompagne
                  les professionnels de l'agriculture dans leur montée en
                  compétences sur les outils numériques.
                </p>

                {/* Stats */}
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
                  <div className="flex items-center gap-2 text-sm text-aspexit-gray">
                    <GraduationCap className="w-5 h-5 text-aspexit-red" />
                    <span>Agronome + Data Scientist</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-aspexit-gray">
                    <BookOpen className="w-5 h-5 text-aspexit-red" />
                    <span>60+ articles publiés</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-aspexit-gray">
                    <Mic className="w-5 h-5 text-aspexit-red" />
                    <span>Conférencier AgriTech</span>
                  </div>
                </div>

                {/* CTA */}
                <div className="flex flex-wrap gap-3">
                  <a
                    href="https://www.linkedin.com/in/corentin-leroux"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-4 py-2 bg-[#0A66C2] text-white rounded-lg text-sm font-medium hover:bg-[#004182] transition-colors"
                  >
                    <Linkedin className="w-4 h-4" />
                    LinkedIn
                  </a>
                  <a
                    href="/contact"
                    className="inline-flex items-center gap-2 px-4 py-2 bg-white border-2 border-border text-aspexit-black rounded-lg text-sm font-medium hover:bg-aspexit-gray-light transition-colors"
                  >
                    En savoir plus
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
